import React, { useEffect, useState } from "react";
import TableOne from "../table/TableOne";
import { getRequest, postRequest, deleteRequest } from "../api/api";
import { Modal, Form, Input, Upload, Button, message, Switch } from "antd";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import "./../style/common.css";
import { FaPlus } from "react-icons/fa6";
import { FaEdit } from "react-icons/fa";
import { BsStars } from "react-icons/bs";
import ReactDOMServer from "react-dom/server";
import { FaTrash, FaTimes } from "react-icons/fa";

const Category = () => {
  const [categories, setCategories] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);

  const getCategories = async () => {
    setLoading(true);
    try {
      const response = await getRequest("categories?all=true");
      // Reverse so newest appears first
      const reversedData = [...(response?.data || [])].reverse();
      setCategories(reversedData);
      console.log("categories-response", reversedData);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  const handleDelete = async (category) => {
   const result = await Swal.fire({
  title: `Are you sure?`,
  html: `This will permanently delete <b>${category.name}</b>.`,
  icon: "warning",
  showCancelButton: true,
  confirmButtonColor: "#d33",
  cancelButtonColor: "#3085d6",
  confirmButtonText: ReactDOMServer.renderToString(
    <>
      <FaTrash style={{ marginRight: 6, verticalAlign: "middle" }} /> Yes, delete it!
    </>
  ),
  cancelButtonText: ReactDOMServer.renderToString(
    <>
      <FaTimes style={{ marginRight: 6, verticalAlign: "middle" }} /> Cancel
    </>
  ),
  allowOutsideClick: false,
});

    if (result.isConfirmed) {
      try {
        await deleteRequest(`categories/${category.id}`);
        Swal.fire(
          "Deleted!",
          `"${category.name}" has been deleted.`,
          "success"
        );
        getCategories();
      } catch (error) {
        console.error("Delete Error:", error);
        Swal.fire("Error", "Failed to delete the Speciality.", "error");
      }
    }
  };

  const handleEdit = (category) => {
    setEditMode(true);
    setEditingCategory(category);
    form.setFieldsValue({
      name: category.name,
      description: category.description,
      is_active:
        category.is_active === "1" || category.is_active === 1 ? true : false, // ✅ prefill
      image: category.image
        ? [
            {
              uid: "-1",
              name: "Existing Image",
              status: "done",
              url: category.image,
            },
          ]
        : [],
    });
    setModalVisible(true);
  };

  const handleAdd = () => {
    setEditMode(false);
    form.resetFields();
    setModalVisible(true);
  };

  const handleFormSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("name", values?.name);
    formData.append("description", values?.description || "");
    const isActiveToSend = editMode ? (values?.is_active ? 1 : 0) : 1;
    formData.append("is_active", isActiveToSend);

    // formData.append("send_notification ", 0);

    const fileList = values.image;
    const fileItem = fileList?.[0];

    if (fileItem?.originFileObj) {
      // ✅ New file selected
      formData.append("image", fileItem?.originFileObj);
    }

    try {
      if (editMode) {
        await postRequest(`categories/${editingCategory.id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Speciality updated successfully");
      } else {
        await postRequest("categories", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Speciality added successfully");
      }

      setModalVisible(false);
      getCategories();
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Sr. No.",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Image",
      key: "image",
      render: (_, record) => {
        const fallbackImage =
          "https://pranafreshharvest.com/profile_images/profile_20251108054906.png";
        const imageUrl = record.image || fallbackImage;
        return (
          <img
            src={imageUrl}
            alt="Submodule"
            width={60}
            height={40}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = fallbackImage;
            }}
          />
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },

    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      render: (value) => {
        const isActive = value === "1" || value === 1;
        return (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              color: isActive ? "#10b981" : "#ef4444",
              fontWeight: "500",
            }}
          >
            <span
              style={{
                height: "8px",
                width: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#10b981" : "#ef4444",
                display: "inline-block",
              }}
            />
            {isActive ? "Active" : "Inactive"}
          </span>
        );
      },
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <div className="header-button">
        <h2
          style={{
            color: "#5a355a",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            lineHeight: 1,
          }}
        >
          <BsStars />
          <span>Specialities</span>
          <span
            style={{
              color: "#979797ff",
              fontSize: "14px",
              fontWeight: 500,
              alignSelf: "flex-end", // 👈 bottom-align just this span
              
            }}
          >
            (Total: {categories?.length ?? 0})
          </span>
        </h2>

        <Button
          type="primary"
          onClick={handleAdd}
          icon={<PlusOutlined />}
          style={{ marginBottom: 20 }}
          className="add-btn"
        >
          Add Specialities
        </Button>
      </div>

      <TableOne
        columns={columns}
        data={categories}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        loading={loading}
      />

      <Modal
        title={editMode ? "Update Specialities" : "Add Specialities"}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        destroyOnClose
        maskClosable={false}
      >
        <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
          <Form.Item
            name="name"
            label="Specialities Name"
            rules={[{ required: true, message: "Required Specialities Name" }]}
            className="custom-form-label"
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            // rules={[{ required: true, message: "Please enter a description" }]}
            className="custom-form-label"
          >
            <Input.TextArea
              rows={6}
              style={{ minHeight: "120px", resize: "vertical" }}
            />
          </Form.Item>

          <Form.Item
            name="image"
            label="Image"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
            className="custom-form-label"
          >
            <Upload
              listType="picture"
              beforeUpload={() => false}
              accept="image/*"
              maxCount={1}
            >
              <Button icon={<UploadOutlined />}>Upload Image</Button>
            </Upload>
          </Form.Item>

{editMode && (
  <Form.Item noStyle shouldUpdate>
    {({ getFieldValue }) => {
      const on = !!getFieldValue("is_active");
      return (
        <Form.Item
          name="is_active"
          label="Status"
          valuePropName="checked"
          className="custom-form-label"
        >
          <Switch
            checkedChildren="Active"
            unCheckedChildren="Inactive"
            className={`status-switch ${on ? "on" : "off"}`}
          />
        </Form.Item>
      );
    }}
  </Form.Item>
)}


          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              className="custom-form-label"
              loading={loading}
              icon={editMode ? <FaEdit /> : <FaPlus />}
            >
              {editMode ? "Update Specialities" : "Add Specialities"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Category;
